module.exports = __webpack_public_path__ + "assets/xxadd.c4c92aeee6522bf427eba71cfe724809.png";